import { Outlet } from 'react-router-dom'
import { Header } from './Header'
import { Sidebar } from './Sidebar'
import { BottomNav } from './BottomNav'
import { useAutoLock } from '@/hooks/useAutoLock'
import { useAuthStore } from '@/stores/authStore'

export function AppShell() {
  useAutoLock()
  const authenticated = useAuthStore((s) => s.authenticated)

  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <div className="flex flex-1">
        {authenticated && <Sidebar />}
        <main className="container flex-1 px-4 py-6 pb-20 md:pb-6">
          <Outlet />
        </main>
      </div>
      {authenticated && <BottomNav />}
    </div>
  )
}
